import React from 'react';
import {map} from 'lodash';

import {
    findDevelopment
} from '../utils.js';
import SkillDevelopment from './SkillDevelopment.js';


export default function ({allSkillData}) {

    const skills_happy = findDevelopment(allSkillData);

    const render_skills = map(skills_happy, (skill_data, skill_code) => {
        return (
            <SkillDevelopment
                key={skill_code}
                skill_data={skill_data}
            />
        );
    });

    return (
        <div className="tsp-development">
            <div className="tsp-header">
                Skill Development
            </div>
            <div className="flex-row flex-gap-25 flex-wrap">
                {render_skills}
            </div>
        </div>
    );
}